const colorsV1 = require("./v1.colors");

const C_GRAY_100 = "#E8E8E8";
const C_GRAY_200 = "#CCCCCC";
const C_GRAY_300 = "#ADADAD";
const C_GRAY_400 = "#909090";
const C_GRAY_500 = "#767676";
const C_GRAY_600 = "#605F5F";
const C_GRAY_700 = "#454444";
const C_GRAY_800 = "#343333";
const C_YELLOW_100 = "#FFFEF6";
const C_YELLOW_200 = "#FFF8D9";
const C_YELLOW_300 = "#FFED9D";
const C_YELLOW_400 = "#FFE465";
const C_YELLOW_500 = "#FFDE17";
const C_YELLOW_600 = "#FFD204";
const C_YELLOW_700 = "#FDBA12";
const C_YELLOW_800 = "#EBA800";
const C_RED = "#EE3B3B";
const C_GREEN = "#38B460";
module.exports.classes = {
  "en-yellow": {
    "100": C_YELLOW_100,
    "200": C_YELLOW_200,
    "300": C_YELLOW_300,
    "400": C_YELLOW_400,
    "500": C_YELLOW_500,
    "600": C_YELLOW_600,
    "700": C_YELLOW_700,
    "800": C_YELLOW_800
  },
  "en-gray": {
    "100": C_GRAY_100,
    "200": C_GRAY_200,
    "300": C_GRAY_300,
    "400": C_GRAY_400,
    "500": C_GRAY_500,
    "600": C_GRAY_600,
    "700": C_GRAY_700,
    "800": C_GRAY_800,
    "900": C_GRAY_800
  },
  "en-red": C_RED,
  "en-green": C_GREEN
};
module.exports.C_GRAY_100 = C_GRAY_100;
module.exports.C_GRAY_200 = C_GRAY_200;
module.exports.C_GRAY_300 = C_GRAY_300;
module.exports.C_GRAY_400 = C_GRAY_400;
module.exports.C_GRAY_500 = C_GRAY_500;
module.exports.C_GRAY_600 = C_GRAY_600;
module.exports.C_GRAY_700 = C_GRAY_700;
module.exports.C_GRAY_800 = C_GRAY_800;
module.exports.C_YELLOW_100 = C_YELLOW_100;
module.exports.C_YELLOW_200 = C_YELLOW_200;
module.exports.C_YELLOW_300 = C_YELLOW_300;
module.exports.C_YELLOW_400 = C_YELLOW_400;
module.exports.C_YELLOW_500 = C_YELLOW_500;
module.exports.C_YELLOW_600 = C_YELLOW_600;
module.exports.C_YELLOW_700 = C_YELLOW_700;
module.exports.C_YELLOW_800 = C_YELLOW_800;
module.exports.C_RED = C_RED;
module.exports.C_GREEN = C_GREEN;
module.exports.v1 = colorsV1;